
import { i18nText } from '@/locales';
import { RouterNameEnum } from "@/router/router.types";
import { RouterProperties } from "@/router/routerProperties";
import { StoreModes } from "../Modes/stores";
export const StoreRoutes = [
    {
        path: "/warehouse",
        redirect: "/warehouse/index",
        component: (): any => import("@/UI/layouts/MainLayout.vue"),
        meta: {
            alias: RouterNameEnum.Stores,
            auth: true,
        },
        children: [
            {
                path: "Stores/:Studio",
                component: (): any => import("@/UI/pages/Stores/Index.vue"),

                name: RouterNameEnum.Stores,
                meta: {
                    alias: RouterNameEnum.Stores,
                    title: "Index",
                    breadcrumb: [{ name: i18nText("Склад"), link: RouterNameEnum.Stores, support: ["studioselect"] }],
                    props: {
                        source: {
                            root: "warehouse",
                            name: "warehouse",
                            items: "warehouse",
                            item: "WarehouseItem",
                            routePage: RouterNameEnum.StoresPage,
                        },
                    },
                },
            },
            {
                path: "Stores/:Studio/page/:page/:total/:filter",
                component: (): any => import("@/UI/pages/Stores/Index.vue"),

                name: RouterNameEnum.StoresPage,
                meta: {
                    alias: RouterNameEnum.Stores,
                    title: "Index",
                    breadcrumb: [{ name: i18nText("Склады"), link: RouterNameEnum.StoresPage, support: ["studioselect"] }],
                    props: {
                        source: {
                            root: "warehouse",
                            name: "warehouse",
                            items: "warehouse",
                            item: "WarehouseItem",
                            routePage: RouterNameEnum.StoresPage,
                        },
                    },

                },
            },
            {
                path: "SelectStore",
                component: (): any => import("@/UI/pages/Stores/Products/SelectStore.vue"),
                props: { source: RouterProperties.warehouse },
                meta: {
                    alias: RouterNameEnum.Stores,
                    title: i18nText("Склады | Выбрать склад"),
                    breadcrumb: [{ name: i18nText("Товары"), link: RouterNameEnum.StoresSelect, support: ["studioselect"] }],
                },
                name: RouterNameEnum.StoresSelect,
            },
            {
                path: "SelectStore/page/:page/:total/:filter",
                component: (): any => import("@/UI/pages/Stores/Products/SelectStore.vue"),
                props: { source: RouterProperties.warehouse },
                meta: {
                    alias: RouterNameEnum.Stores,
                    title: i18nText("Склады | Выбрать склад"),
                    breadcrumb: [{ name: i18nText("Товары"), link: RouterNameEnum.StoresSelectPage, support: ["studioselect"] }],
                },
                name: RouterNameEnum.StoresSelectPage,
            },
            {
                path: "ListedProducts/:Studio/:idCategory",
                component: (): any => import("@/UI/pages/Stores/Products/Listed/Index.vue"),
                //props: { source: RouterProperties.products },

                meta: {
                    alias: RouterNameEnum.ListedProducts,
                    title: i18nText("Склады | номенклатура Товаров"),
                    breadcrumb: [
                        { name: i18nText("Товары"), support: ["studioselect"] }
                    ],
                    props: {
                        source: {
                            root: "products",
                            name: "products",
                            items: "products",
                            item: "product",
                            routePage: RouterNameEnum.ListedProductsPage,
                        },
                    },
                },
                name: RouterNameEnum.ListedProducts,
            },
            {
                path: "ListedProducts/:Studio/:idCategory/page/:page/:total/:filter",
                component: (): any => import("@/UI/pages/Stores/Products/Listed/Index.vue"),
                meta: {
                    alias: RouterNameEnum.ListedProducts,
                    title: i18nText("Склады | номенклатура Товаров"),
                    breadcrumb: [
                        { name: i18nText("Товары"), support: ["studioselect"] },
                    ],
                    props: {
                        source: {
                            root: "products",
                            name: "products",
                            items: "products",
                            item: "product",
                            routePage: RouterNameEnum.ListedProductsPage,
                        },
                    },
                },
                name: RouterNameEnum.ListedProductsPage,
            },
            {
                path: "Products/:Store",
                component: (): any => import("@/UI/pages/Stores/Products/Index.vue"),
                props: { source: RouterProperties.products },
                meta: {
                    alias: RouterNameEnum.ListedProducts,
                    title: i18nText("Склады | Товары"),
                    breadcrumb: [{ name: i18nText("Товары"), link: RouterNameEnum.StoresProducts, support: ["studioselect"] }],
                },
                name: RouterNameEnum.StoresProducts,
            },
            {
                path: "Products/:Store/page/:page/:total/:filter",
                component: (): any => import("@/UI/pages/Stores/Products/Index.vue"),

                props: { source: RouterProperties.products },
                name: RouterNameEnum.StoresProductsPage,
                meta: {
                    alias: RouterNameEnum.ListedProducts,
                    title: "Index",
                    breadcrumb: [
                        { name: i18nText("Товары"), link: RouterNameEnum.StoresProductsPage, support: ["studioselect"] },
                    ],
                },
            },
            {
                path: "Products/Archived",
                props: { source: RouterProperties.products_archived },
                meta: {
                    alias: RouterNameEnum.ListedProducts,
                    title: i18nText("Склады | Товары Архив"),
                    breadcrumb: [
                        { name: i18nText("Товары"), link: "ListedProducts" },
                        { name: i18nText("Архивация") }
                    ],
                },
                name: RouterNameEnum.StoresProductsArchived,
                component: (): any => import("@/UI/pages/Stores/Products/Archive.vue"),
            },
            {
                path: "Products/Archived/page/:page/:total/:filter",
                component: (): any => import("@/UI/pages/Stores/Products/Archive.vue"),
                props: { source: RouterProperties.products_archived },
                name: RouterNameEnum.StoresProductsPageArchived,
                meta: {
                    alias: RouterNameEnum.ListedProducts,
                    title: "Index",
                    breadcrumb: [
                        { name: i18nText("Товары"), link: "ListedProducts" },
                        { name: i18nText("Архивация") }
                    ],
                },
            },
            {
                path: "Products/MassEdit",
                props: { source: RouterProperties.products_mass },
                meta: {
                    alias: RouterNameEnum.ListedProducts,
                    title: i18nText("Склады | Массовое редактирование"),
                    breadcrumb: [
                        { name: i18nText("Товары"), link: "ListedProducts" },
                        { name: i18nText("Массовое редактирование") }
                    ],
                },
                name: RouterNameEnum.StoresProductsMassEdit,
                component: (): any => import("@/UI/pages/Stores/Products/mIndex.vue"),
            },
            {
                path: "Products/MassEdit/:page/:total/:filter",
                props: { source: RouterProperties.products_mass },
                meta: {
                    alias: RouterNameEnum.ListedProducts,
                    title: i18nText("Склады | Массовое редактирование"),
                    breadcrumb: [
                        { name: i18nText("Товары"), link: "ListedProducts" },
                        { name: i18nText("Массовое редактирование") }
                    ],
                },
                name: RouterNameEnum.StoresProductsMassEditPage,
                component: (): any => import("@/UI/pages/Stores/Products/mIndex.vue"),
            },

            {
                path: "Products/Create/:fromCategory/:Studio",
                meta: {
                    alias: RouterNameEnum.ListedProducts,
                    title: i18nText("Склады | Товары | Добавить товар"),
                    breadcrumb: [
                        { name: i18nText("Товары"), link: "ListedProducts" },
                        { name: i18nText("Новый товар"), support: ["closeButton"] }
                    ],
                },
                props: { source: "products", mode: 0 },
                name: RouterNameEnum.StoresProductsCreate,
                component: (): any => import("@/UI/pages/Stores/Products/Data.vue"),
            },
            {
                path: "Products/Data/:id",
                meta: {
                    alias: RouterNameEnum.ListedProducts,
                    title: i18nText("Склады | Товары"),
                    breadcrumb: [
                        {
                            name: i18nText("товар"),
                            link: RouterNameEnum.StoresProductPage,
                            // support: ["submitButton", "closeButton"],
                            support: ["closeButton"],
                        },
                    ],
                },
                props: { source: "products", mode: 1 },
                name: RouterNameEnum.StoresProductPage,
                component: (): any => import("@/UI/pages/Stores/Products/Data.vue"),
            },
            {
                path: "Operations/Report/:Studio/:Data",
                component: (): any => import("@/UI/pages/Stores/Operations/Report.vue"),
                name: RouterNameEnum.StoreOperationsReport,
                meta: {
                    alias: RouterNameEnum.StoreOperations,
                    title: i18nText("Склады | Складские операции | Оплачено полностью"),
                    breadcrumb: [
                        {
                            link: RouterNameEnum.StoreOperationsReport,
                        },
                    ],
                },
            },
            {
                path: "Operations/Sale/:Studio/:id",
                component: (): any => import("@/UI/pages/Stores/Operations/Sale/Index.vue"),
                name: RouterNameEnum.StoreOperationsSale,
                props: { mode: StoreModes.sale },
                meta: {
                    alias: RouterNameEnum.StoreOperations,
                    title: i18nText("Склады | Складские операции | Продажа товара"),
                    breadcrumb: [
                        { name: i18nText("Складские операции"), link: "StoreOperations" },
                        { name: i18nText("Продажа товара"), support: ["closeButton"] },
                    ],
                },
            },
            {
                path: "Operations/get/:Studio/:id",
                component: (): any => import("@/UI/pages/Stores/Operations/Sale/Index.vue"),
                name: RouterNameEnum.StoreOperationsGet,
                props: { mode: StoreModes.get },
                meta: {
                    alias: RouterNameEnum.StoreOperations,
                    title: i18nText("Склады | Продолжение операции"),
                    breadcrumb: [
                        {
                            name: i18nText("Операция Изменение операции"),
                            link: RouterNameEnum.StoreOperationsGet,
                            support: ["closeButton"],
                        },
                    ],
                },
            },
            {
                path: "Operations/writeOff/:id/:Studio?",
                component: (): any => import("@/UI/pages/Stores/Operations/Sale/Index.vue"),
                name: RouterNameEnum.StoreOperationsWriteOff,
                props: { mode: StoreModes.writeOff },
                meta: {
                    alias: RouterNameEnum.StoreOperations,
                    title: i18nText("Склады | Складские операции | Списание товара"),
                    breadcrumb: [
                        { name: i18nText("Складские операции"), link: "StoreOperations" },
                        { name: i18nText("Списание товара"), support: ["closeButton"] }
                    ],
                },
            },
            {
                path: "Operations/arrival/:Studio/:id",
                component: (): any => import("@/UI/pages/Stores/Operations/Sale/Index.vue"),
                name: RouterNameEnum.StoreOperationsArrival,
                props: { mode: StoreModes.arrival },
                meta: {
                    alias: RouterNameEnum.StoreOperations,
                    title: i18nText("Склады | Складские операции | Приход товара"),
                    breadcrumb: [
                        { name: i18nText("Складские операции"), link: "StoreOperations" },
                        { name: i18nText("Приход товара"), support: ["closeButton"] },
                    ],
                },
            },
            {
                path: "Operations/move/:Studio",
                component: (): any => import("@/UI/pages/Stores/Operations/Move/Index.vue"),
                name: RouterNameEnum.StoreOperationsMove,
                meta: {
                    alias: RouterNameEnum.StoreOperations,
                    title: i18nText("Склады | Складские операции | Перемещение товаров"),
                    breadcrumb: [
                        { name: i18nText("Складские операции"), link: "StoreOperations" },
                        { name: i18nText("Перемещение товара"), support: ["closeButton"] },
                    ],
                },
            },

            {
                path: "Operations/:Studio/",
                component: (): any => import("@/UI/pages/Stores/Operations/Index.vue"),

                name: RouterNameEnum.StoreOperations,
                meta: {
                    alias: RouterNameEnum.StoreOperations,
                    title: i18nText("Склады | Складские операции"),
                    breadcrumb: [
                        { name: i18nText("Складские операции"), support: ["studioselect"] },
                    ],
                    props: {
                        source: {
                            root: "operations",
                            name: "operations",
                            items: "operations",
                            item: "operation",
                            routePage: RouterNameEnum.StoreOperationsPage,
                        },
                    },
                },
            },

            {
                path: "Operations/:Studio/page/:page/:total/:filter",
                component: (): any => import("@/UI/pages/Stores/Operations/Index.vue"),
                //props: { source: RouterProperties.operations },

                name: RouterNameEnum.StoreOperationsPage,
                meta: {
                    alias: RouterNameEnum.StoreOperations,
                    title: i18nText("Склады | Складские операции"),
                    breadcrumb: [
                        {
                            name: i18nText("Движение товаров"),
                            link: RouterNameEnum.StoreOperationsPage,
                            support: ["studioselect"],
                        },
                    ],
                    props: {
                        source: {
                            root: "operations",
                            name: "operations",
                            items: "operations",
                            item: "operation",
                            routePage: RouterNameEnum.StoreOperationsPage,
                        },
                    },
                },
            },
        ],
    },
];
